exports.AgChartsReact = require('./lib/agChartsReact').AgChartsReact;